import React from 'react'

import './banner-header.scss'

const BannerHeader = (props) => {
  const { bannerInformation, isMobile } = props

  return (
    <div className="f-banner-header">
      <figure className="f-banner-header__image">
        <a href={bannerInformation[0].redireccionBanner ? bannerInformation[0].redireccionBanner : '#'} target="_blank">
          <img
            src={
              !isMobile
                ?
                bannerInformation[0].imagenesBanner[0].file.url
                :
                bannerInformation[0].imagenesBanner[1].file.url
            }
            alt={
              !isMobile
                ?
                bannerInformation[0].imagenesBanner[0].title
                :
                bannerInformation[0].imagenesBanner[1].title
            }
          />
        </a>
      </figure>

      {

        bannerInformation[0].tituloBanner ?
          <>
            <div className="f-banner-header__container-description">
              <div className="f-banner-header__container-description__container">
                <img className="f-banner-header__container-description__container-icon" src={bannerInformation[0].iconoBanner.file.url} alt={bannerInformation[0].iconoBanner.file.fileName} />
                <h1 className="f-banner-header__container-description__container-title">
                  {bannerInformation[0].tituloBanner}
                </h1>
              </div>
              <p className="f-banner-header__container-description-info">
                {bannerInformation[0].descripcionBanner.json.content[0].content[0].value}
              </p>
            </div>
          </> : null
      }

      {/* {
        bannerInformation[0].tituloIndicador
          ?
          <>
            <div className="f-banner-header__container-indicator">
              <div className="f-banner-header__container-indicator-header">
                <p className="f-text-indicator">
                  {
                    bannerInformation[0].tituloIndicador
                  }
                </p>
              </div>
              <div className="f-banner-header__container-indicator-body">
                <div className="f-text-indicator big">
                  <div></div>
                  {
                    bannerInformation[0].porcentajeIndicador
                  }
                </div>
                <p className="f-text-indicator small">
                  {
                    bannerInformation[0].descripcionIndicador
                  }
                </p>
              </div>
            </div>
            <div className="f-banner-header__decorator"></div>
          </>
          :
          null
      } */}
    </div>
  )
}

export default BannerHeader
